import React from "react";
import { Link } from "gatsby";
import dasmagazinLogo from "../../images/dasmagazin.svg";
var MakroskopLink = function MakroskopLink(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, /*#__PURE__*/ React.createElement("img", {
        src: dasmagazinLogo,
        alt: "Makroskop"
    })));
};
export default MakroskopLink;
